import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const ListOfVehiclesPendingGateInwards = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [gateInNo, setGateInNo] = useState("");
  const [firstGateInNo, setFirstGateInNo] = useState("");
  const [lastGateInNo, setLastGateInNo] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [date, setDate] = useState(new Date().toISOString());
  const [driverCode, setDriverCode] = useState("");
  const [driverName, setDriverName] = useState("");
  const [comments, setComments] = useState("");
  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString(),
  );
  const [driversList, setDriversList] = useState([]);
  const [gateList, setGateList] = useState([]);
  const [gateIn, setGateIn] = useState("");
  const [gateInName, setGateInName] = useState("");

  const [proceedToState, setProceedToState] = useState("");
  const [proceedToStateValue, setProceedToStateValue] = useState("");
  const [returns, setReturns] = useState(false);
  const [clientsList, setClientsList] = useState([]);
  const [returnsClient, setreturnsClient] = useState("");
  const [returnsClientCode, setReturnsClientCode] = useState("");
  const [wbData, setWbData] = useState([]);
  const [wbName, setWbName] = useState("");
  const [wbNo, setWbNo] = useState("");
  const [WeighBridgeData, setWeighBridgeData] = useState([]);
  const [noOfVehicles, setNoOfVehicles] = useState("");

  const [histData, setHistData] = useState([]);
  const [showHist, setShowhist] = useState(false);
  const [searchHist, setSearchHist] = useState("");
  const [startDateHist, setStartDateHist] = useState("");
  const [endDateHist, setEndDateHist] = useState("");
  const [hist, setHist] = useState(false);

  // Filtered Hist Data
  const filtHist = histData?.filter((item) => {
    const searchData = searchHist?.toLowerCase().split(" ").filter(Boolean);
    const sDate = new Date(item.OT_GATE_IN_DATE);
    const eDate = new Date(item.OT_GATE_IN_DATE);
    const startDate = startDateHist ? new Date(startDateHist) : null;
    const endDate = endDateHist ? new Date(endDateHist) : null;

    const driver = driversList?.find(
      (value) => value?.DRIVERCODE === item?.OT_DRIVER_CODE,
    );

    const gate = gateList?.find((value) => value?.GATEID === item?.OT_GATE_NO);

    const textMatch = searchData.every((term) => {
      const driverMatch =
        driver?.DRIVERNAME?.toLowerCase()?.includes(term) ?? false;

      const gateMatch = gate?.GATENAME?.toLowerCase()?.includes(term) ?? false;

      const otherMatch = [
        "OT_GATE_IN_NO",
        "OT_GATE_IN_VEHICLE",
        "OT_GATE_IN_COMMENT",
      ].some((key) => {
        const columnValue = String(item[key] || "").toLowerCase();
        return columnValue.includes(term);
      });

      return driverMatch || gateMatch || otherMatch;
    });

    const dateMatch =
      (!startDate || sDate >= startDate) && (!endDate || eDate <= endDate);

    return textMatch && dateMatch;
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer,
  );

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE REG NO",
        "DRIVERNAME",
        "MAKE",
        "MODEL",
        "TRAILER NAME ATTACHED",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1057`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setGateInNo(response?.data[0]?.NEW_OT_GATE_IN_NO);
        setLastGateInNo(response?.data[0]?.NEW_OT_GATE_IN_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    // Client's List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=599`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setClientsList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Client Details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1264`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setWbData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching WeighBridge details:", error);
      });

    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1060`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then((response) => {
    //     const filterData = response?.data?.filter(
    //       (item) =>
    //         item.OT_VERIFICATION_PROCEED_TO_STATE === "SENT FOR WEIGHBRIDGE",
    //     );
    //     setWeighBridgeData(filterData);
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching Driver details:", error);
    //   });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1228`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setWeighBridgeData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1261`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filteredData = response?.data?.filter(
          (item) => item?.ENTRYEXIT === "ENTRY",
        );
        setGateList(filteredData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Gate List details 1261:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=367`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const sortedData = response?.data?.sort(
          (a, b) => a.OT_GATE_IN_NO - b.OT_GATE_IN_NO,
        );
        setHistData(sortedData);
        setFirstGateInNo(sortedData?.[0]?.OT_GATE_IN_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Gate List details 367:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        if (VehicleDepartment !== "") {
          const filterData = response?.data?.filter(
            (item) =>
              item.VEHICLESTATE === "GATE OUT" &&
              item.TRAILER === false &&
              item?.DEPARTMENT === VehicleDepartment,
          );
          // setVehiclesList(filterData);
          // if (filterData?.length === 0) {
          //   setShowGateIn(true)
          // }
        } else {
          const filterData = response?.data?.filter(
            (item) =>
              item.VEHICLESTATE === "GATE OUT" && item.TRAILER === false,
          );
          setVehiclesList(filterData);
           if (filterData?.length === 0) {
              setShowGateIn(true)
            }
        }
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
  };

  // Saving
  async function SaveGateIn() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1055`,
        {
          OT_GATE_IN_NO: Number(gateInNo),
          OT_GATE_IN_DATE: moment(date).format("YYYY/MM/DD"),
          OT_GATE_IN_TIME: currentTime,
          OT_GATE_IN_VEHICLE: vehicleNo,
          OT_DRIVER_CODE: driverCode,
          OT_GATE_NO: Number(gateIn),
          OT_GATE_IN_COMMENT: comments,
          OT_GATE_IN_RETURNS: returns === true ? 1 : 0,
          OT_RETURN_CLIENT_NAME: returnsClientCode ? returnsClientCode : "",
          OT_PROCEED_TO: proceedToStateValue,
          OT_PROCEED_TO_WEIGHBRIDGE_NO: wbNo ? Number(wbNo) : 0,
          OT_GATE_CREATED_BY: user,
          OT_GATE_IN_NEW_EXISTING: hist === true ? "EXISTING" : "NEW",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        // setisloading(false);
        console.log(`Gate In successfully`);
        await SaveVehicleState(response?.data?.message);
      } else {
        setisloading(false);
        console.error(`Error while saving Gate In`);
        alert(`Error while saving Gate In`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Gate In`, error);
      alert(`Error while saving Gate In`, error);
    }
  }

  async function SaveVehicleState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE: proceedToStateValue
            ? proceedToStateValue
            : "GATE IN",
          OT_VEHICLE_STATE_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTime,
          OT_VEHICLE_PREVIOUS_STATE: "GATE OUT",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        // setisloading(false);
        // alert(`Vehicle State Updated successfully`);
        await SaveState(docNo);
        console.log(`Vehicle State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Vehicle State`);
        alert(`Error while saving Vehicle State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Vehicle State `, error);
      alert(`Error while saving Vehicle State `, error);
    }
  }

  async function SaveState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1121`,
        {
          TRANSTYPE: "GATE IN",
          DOC_NO: Number(docNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Gate In successfully`);
        // alert(`State Updated successfully`);
        console.log(`State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving State`);
        alert(`Error while saving State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving State `, error);
      alert(`Error while saving State `, error);
    }
  }

  const handleRowClick = (value, index) => {
    setVehicleNo(value["VEHICLE REG NO"]);
    setDriverCode(value.DRIVERCODE);
    setDriverName(value.DRIVERNAME);
    setGateInName("");
    setGateIn("");
    setShowGateIn(true);
  };

  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      "List Of Vehicles Pending Gate Inwards And Verification",
    );
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [15, 15, 15, 15, 50];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "GATE IN NO",
      "VEHICLE",
      "DATE",
      "TIME",
      "COMMENTS",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download =
        "List_Of_Vehicles_Pending_Gate_Inwards_And_Verification.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    const doc = new jsPDF();

    doc.text(
      "List Of Vehicles Pending Gate Inwards And Verification - Report",
      10,
      10,
    );

    const columns = ["GATE IN NO", "VEHICLE", "DATE", "TIME", "COMMENTS"];
    const data = filtHist.map((stock) => [
      stock.OT_GATE_IN_NO,
      stock.OT_GATE_IN_VEHICLE,
      stock.OT_GATE_IN_DATE
        ? moment(stock.OT_GATE_IN_DATE).format("DD/MM/YYYY")
        : "",
      stock.OT_GATE_IN_TIME
        ? moment(stock.OT_GATE_IN_TIME).format("hh:MM:ss")
        : "",
      stock.OT_GATE_IN_COMMENT,
    ]);

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("List_Of_Vehicles_Pending_Gate_Inwards_And_Verification.pdf");
  };

  const handleButtonClick = (action) => {
    let gateInNoToPass;
    switch (action) {
      case "first":
        gateInNoToPass = Number(firstGateInNo);
        break;
      case "decrement":
        gateInNoToPass = Number(gateInNo) - 1;
        if (gateInNoToPass < Number(firstGateInNo)) {
          alert("Cannot decrement further");
          return;
        }
        break;

      case "increment":
        gateInNoToPass = Number(gateInNo) + 1;
        if (gateInNoToPass >= Number(lastGateInNo)) {
          alert("No Further PO number");
          return;
        }
        break;

      case "latest":
        gateInNoToPass = Number(lastGateInNo) - 1;
        break;
      default:
        break;
    }

    setGateInNo(gateInNoToPass);
    getNavData(gateInNoToPass);
  };

  async function getNavData(gateIn) {
    const item = histData?.find((value) => value?.OT_GATE_IN_NO === gateIn);

    if (item) {
      setGateInNo(item?.["OT_GATE_IN_NO"]);
      setVehicleNo(item?.["OT_GATE_IN_VEHICLE"]);
      setDate(item?.["OT_GATE_IN_DATE"]);
      setCurrentTime(
        item?.["OT_GATE_IN_TIME"]
          ? item?.["OT_GATE_IN_TIME"]?.split("T")[1]?.slice(0, 8)
          : "",
      );
      setDriverCode(item?.["OT_DRIVER_CODE"]);
      const driver = driversList?.find(
        (row) => row?.DRIVERCODE === item?.["OT_DRIVER_CODE"],
      );
      setDriverName(driver?.DRIVERNAME);
      setReturns(item?.OT_GATE_IN_RETURNS === true ? true : false);
      const client = clientsList?.find(
        (row) => row?.CLIENTCODE === item?.OT_RETURN_CLIENT_NAME,
      );
      setReturnsClientCode(item?.OT_RETURN_CLIENT_NAME);
      setreturnsClient(client?.CLIENTNAME);

      setProceedToStateValue(item?.OT_PROCEED_TO);
      if (item?.OT_PROCEED_TO === "SENT TO WORKSHOP") {
        setProceedToState("PROCEED TO WORKSHOP");
      } else if (item?.OT_PROCEED_TO === "SENT FOR RETURNS") {
        setProceedToState("PROCEED TO RETURNS");
      } else if (item?.OT_PROCEED_TO === "SENT FOR WEIGHBRIDGE") {
        setProceedToState("PROCEED TO WEIGHBRIDGE");

        setWbNo(item?.OT_PROCEED_TO_WEIGHBRIDGE_NO);
        const wb = wbData?.find(
          (row) => row?.WBNUMBER === item?.OT_PROCEED_TO_WEIGHBRIDGE_NO,
        );

        setWbName(wb?.WBNAME);
        const weigh = WeighBridgeData?.filter(
          (row) =>
            row?.WEIGHBRIDGENUMBER === item?.OT_PROCEED_TO_WEIGHBRIDGE_NO,
        );
        setNoOfVehicles(weigh?.length);
      }
      setComments(item?.["OT_GATE_IN_COMMENT"]);

      setGateIn(item?.OT_GATE_NO);
      const gate = gateList?.find((row) => row?.GATEID === item?.OT_GATE_NO);
      setGateInName(gate?.GATENAME);
      setHist(true)
    } else {
      // Auto-decrement if record not found
      const allVouchers = [...(histData || [])]
        .map((item) => Number(item?.OT_GATE_IN_NO))
        .sort((a, b) => a - b);

      const currentGateInNo = Number(gateIn);

      // Determine whether this was likely an increment or decrement action
      const lastGateInNos = Number(gateInNo);

      const isIncrement = currentGateInNo > lastGateInNos;

      if (isIncrement) {
        // Find next existing record greater than the current one
        const nextExisting = allVouchers.find((num) => num > currentGateInNo);
        if (nextExisting !== undefined) {
          console.warn(`gateIn No ${gateIn} not found, trying ${nextExisting}`);
          await getNavData(nextExisting);
          return;
        } else {
          alert(`No further gateIn No found after ${gateIn}`);
        }
      } else {
        const previousExisting = [...allVouchers]
          .reverse()
          .find((num) => num < Number(gateIn));

        if (previousExisting !== undefined) {
          console.warn(
            `gateIn No ${gateIn} not found, trying ${previousExisting}`,
          );
          await getNavData(previousExisting);
          return;
        } else {
          alert(`No existing gateIn No found before ${gateIn}`);
        }
      }
    }
  }

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen p-4">
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          List Of Vehicles Pending Gate Inwards And Verification
        </h1>
        <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        />
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MODEL
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER ATTACHED ?
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ATTACHED NAME TRAILER
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["VEHICLE REG NO"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["DRIVERNAME"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MODEL || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER ATTACHED"] === true
                    ? "YES"
                    : value["TRAILER ATTACHED"] === false
                      ? "NO"
                      : "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER NAME ATTACHED"] || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[400px] h-[65%] lg:w-[1000px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="text-3xl font-bold flex lg:justify-center justify-start">
            GATE IN
          </h1>

          <div className="flex lg:ml-2 gap-1 lg:mr-2">
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("first");
              }}
            >
              {"<<"}
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("decrement");
              }}
            >
              {"<"}
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("increment");
              }}
            >
              {">"}
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                handleButtonClick("latest");
              }}
            >
              {">>"}
            </button>
          </div>
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">GateIn No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={gateInNo}
              readOnly
            ></input>

            <button
              className="border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-1 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                setShowhist(true);
              }}
            >
              ...
            </button>

            {showHist && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[300px] h-[80%] lg:w-[900px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={searchHist}
                    onChange={(e) => {
                      setSearchHist(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">Start Date:</p>
                  <input
                    className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={startDateHist?.split("T")[0]}
                    onChange={(e) => {
                      setStartDateHist(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">End Date:</p>
                  <input
                    className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={endDateHist?.split("T")[0]}
                    onChange={(e) => {
                      setEndDateHist(e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setShowhist(false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[250px] p-1 z-0 lg:overflow-auto mt-2">
                  <div className="flex justify-end gap-2">
                    <div className="cursor-pointer">
                      <RiFileExcel2Line onClick={ExcelStockData} size={25} />
                    </div>
                    <div className="cursor-pointer">
                      <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
                    </div>
                  </div>

                  <table className="w-full border border-gray-300 text-sm table_1">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px] table-header">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Gate In No
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Vehicle
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Driver
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Date
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Time
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Gate
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Comments
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtHist?.map((item, index) => {
                        const driver = driversList?.find(
                          (row) => row?.DRIVERCODE === item?.["OT_DRIVER_CODE"],
                        );
                        const gate = gateList?.find(
                          (value) => value?.GATEID === item?.OT_GATE_NO,
                        );
                        return (
                          <tr
                            className="hover:bg-gray-100 cursor-pointer text-[13px]"
                            onClick={() => {
                              setGateInNo(item?.["OT_GATE_IN_NO"]);
                              setVehicleNo(item?.["OT_GATE_IN_VEHICLE"]);
                              setDate(item?.["OT_GATE_IN_DATE"]);
                              setCurrentTime(item?.["OT_GATE_IN_TIME"]);
                              setDriverCode(item?.["OT_DRIVER_CODE"]);
                              const driver = driversList?.find(
                                (row) =>
                                  row?.DRIVERCODE === item?.["OT_DRIVER_CODE"],
                              );
                              setDriverName(driver?.DRIVERNAME);
                              setReturns(
                                item?.OT_GATE_IN_RETURNS === true
                                  ? true
                                  : false,
                              );
                              const client = clientsList?.find(
                                (row) =>
                                  row?.CLIENTCODE ===
                                  item?.OT_RETURN_CLIENT_NAME,
                              );
                              setReturnsClientCode(item?.OT_RETURN_CLIENT_NAME);
                              setreturnsClient(client?.CLIENTNAME);

                              setProceedToStateValue(item?.OT_PROCEED_TO);
                              if (item?.OT_PROCEED_TO === "SENT TO WORKSHOP") {
                                setProceedToState("PROCEED TO WORKSHOP");
                              } else if (
                                item?.OT_PROCEED_TO === "SENT FOR RETURNS"
                              ) {
                                setProceedToState("PROCEED TO RETURNS");
                              } else if (
                                item?.OT_PROCEED_TO === "SENT FOR WEIGHBRIDGE"
                              ) {
                                setProceedToState("PROCEED TO WEIGHBRIDGE");

                                setWbNo(item?.OT_PROCEED_TO_WEIGHBRIDGE_NO);
                                const wb = wbData?.find(
                                  (row) =>
                                    row?.WBNUMBER ===
                                    item?.OT_PROCEED_TO_WEIGHBRIDGE_NO,
                                );

                                setWbName(wb?.WBNAME);
                                const weigh = WeighBridgeData?.filter(
                                  (row) =>
                                    row?.WEIGHBRIDGENUMBER ===
                                    item?.OT_PROCEED_TO_WEIGHBRIDGE_NO,
                                );
                                setNoOfVehicles(weigh?.length);
                              }
                              setComments(item?.["OT_GATE_IN_COMMENT"]);

                              setGateIn(item?.OT_GATE_NO);
                              const gate = gateList?.find(
                                (row) => row?.GATEID === item?.OT_GATE_NO,
                              );
                              setGateInName(gate?.GATENAME);
                              setShowhist(false);
                              setHist(true)
                            }}
                            key={index}
                          >
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item?.["OT_GATE_IN_NO"]
                                ? item?.["OT_GATE_IN_NO"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_GATE_IN_VEHICLE"]
                                ? item?.["OT_GATE_IN_VEHICLE"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {driver?.["DRIVERNAME"]
                                ? driver?.["DRIVERNAME"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_GATE_IN_DATE"]
                                ? moment(item?.["OT_GATE_IN_DATE"]).format(
                                    "DD/MM/YYYY",
                                  )
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_GATE_IN_TIME"]
                                ? moment(item?.["OT_GATE_IN_TIME"]).format(
                                    "hh:MM:ss",
                                  )
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {gate?.["GATENAME"] ? gate?.["GATENAME"] : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {item?.["OT_GATE_IN_COMMENT"]
                                ? item?.["OT_GATE_IN_COMMENT"]
                                : "NA"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <p className="text-red-600 lg:ml-4">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-2">Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-12 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-4">Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>
          </div>
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Driver:</p>
            <Select
              className="lg:w-72 w-64 lg:ml-10"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driverName
                  ? { value: driverName, label: driverName }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriverName(e.label);
                setDriverCode(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERCODE,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-2">Gate :</p>
            <Select
              className="lg:w-72 w-64 lg:ml-12"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                gateInName
                  ? { value: gateInName, label: gateInName }
                  : { value: "", label: "Select Gate In" }
              }
              onChange={(e) => {
                setGateInName(e.label);
                setGateIn(e.value);
              }}
              options={[
                { value: "", label: "Select Gate In" },
                ...gateList?.map((item) => ({
                  value: item.GATEID,
                  label: item.GATENAME,
                })),
              ]}
            ></Select>
          </div>
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Returns ?:</p>
            <input
              className="w-6 h-6 border border-black lg:ml-2 rounded-md focus:outline-none focus:border-blue-500"
              type="checkbox"
              checked={returns}
              onChange={(e) => {
                const isChecked = e.target.checked;
                setReturns(isChecked);
                if (isChecked) {
                  setProceedToState("PROCEED TO RETURNS");
                  setProceedToStateValue("SENT FOR RETURNS");
                } else {
                  setProceedToState("");
                  setProceedToStateValue("");
                }
              }}
            ></input>

            <p className="text-red-600 lg:ml-2 w-[100px]">Returns Client :</p>
            <Select
              className="lg:w-64 lg:ml-2"
              menuPortalTarget={document.body} // ⬅️ Renders dropdown at body level
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ Forces on top
              }}
              value={
                returnsClient
                  ? { value: returnsClient, label: returnsClient }
                  : { value: "", label: "Select Client" }
              }
              onChange={(e) => {
                if (e.value !== "") {
                  setreturnsClient(e.value);
                  const compliance = clientsList.find(
                    (item) => item.CLIENTNAME === e.value,
                  );
                  setReturnsClientCode(compliance?.CLIENTCODE);
                } else {
                  setreturnsClient("");
                }
              }}
              options={[
                { value: "", label: "Select Client" },
                ...clientsList?.map((item) => ({
                  value: item.CLIENTNAME,
                  label: item.CLIENTNAME,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-2">Proceed To :</p>
            <Select
              className="lg:w-64 lg:ml-2"
              menuPortalTarget={document.body} // ⬅️ Renders dropdown at body level
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ Forces on top
              }}
              value={
                proceedToState
                  ? { value: proceedToState, label: proceedToState }
                  : { value: "", label: "Select State" }
              }
              onChange={(e) => {
                setProceedToState(e.label);
                setProceedToStateValue(e.value);
              }}
              options={[
                { value: "", label: "Select State" },
                { value: "SENT TO WORKSHOP", label: "PROCEED TO WORKSHOP" },
                { value: "SENT TO LOAD", label: "PROCEED TO LOAD" },
                { value: "SENT FOR RETURNS", label: "PROCEED TO RETURNS" },
                {
                  value: "SENT FOR WEIGHBRIDGE",
                  label: "PROCEED TO WEIGHBRIDGE",
                },
              ]}
            ></Select>
          </div>

          {proceedToState === "PROCEED TO WEIGHBRIDGE" && (
            <div className="lg:flex lg:flex-row mt-2">
              <p className="text-red-600 lg:ml-2">WeighBridge :</p>
              <Select
                className="lg:w-64 lg:ml-2"
                menuPortalTarget={document.body} // ⬅️ Renders dropdown at body level
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ Forces on top
                }}
                value={
                  wbName
                    ? { value: wbName, label: wbName }
                    : { value: "", label: "Select WeighBridge" }
                }
                onChange={(e) => {
                  if (e.value !== "") {
                    setWbName(e.label);
                    setWbNo(e.value);
                    const weigh = WeighBridgeData?.filter(
                      (item) => item?.WEIGHBRIDGENUMBER === e.value,
                    );
                    setNoOfVehicles(weigh?.length);
                  }
                }}
                options={[
                  { value: "", label: "Select WeighBridge" },
                  ...wbData?.map((item) => ({
                    value: item.WBNUMBER,
                    label: item.WBNAME,
                  })),
                ]}
              ></Select>
              <p className="text-red-600 lg:ml-2">No Of Vehicles :</p>
              <input
                className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                type="number"
                value={noOfVehicles}
                readOnly
              ></input>
            </div>
          )}

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Comments :</p>
            <textarea
              rows={2}
              className="lg:w-[400px] w-[370px] resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            ></textarea>
          </div>

          <div className="flex justify-center mt-5">
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                if (!driverName) {
                  alert("Kindly Supply Driver");
                  return;
                } else if (!gateInName) {
                  alert("Kindly Supply Gate");
                  return;
                } else if (returns === true && !returnsClient) {
                  alert("Kindly Supply Returns Client");
                  return;
                } else if (!proceedToState) {
                  alert("Kindly Supply Proceed To");
                  return;
                } else if (
                  proceedToState === "PROCEED TO WEIGHBRIDGE" &&
                  !wbName
                ) {
                  alert("Kindly Supply Weighbridge");
                  return;
                } else if (!comments) {
                  alert("Kindly Supply Comments");
                  return;
                } else {
                  await SaveGateIn();
                  setShowGateIn(false);
                  window.location.reload();
                }
              }}
            >
              Process Gate In
            </button>
          </div>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default ListOfVehiclesPendingGateInwards;
